import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)
const _hoisted_2 = { class: "shell padding30px" }
const _hoisted_3 = {
  key: 1,
  class: "info-container"
}
const _hoisted_4 = { class: "info-light-title" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = { class: "info-label-title" }
const _hoisted_8 = { class: "info-label-content" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = { class: "info-label-title" }
const _hoisted_11 = { class: "info-label-content" }
const _hoisted_12 = { class: "info-item" }
const _hoisted_13 = { class: "info-label-title" }
const _hoisted_14 = { class: "info-label-content" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)
const _hoisted_16 = { class: "info-light-title" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)
const _hoisted_18 = { class: "info-item display-flex align-items-center" }
const _hoisted_19 = { class: "info-label-title" }
const _hoisted_20 = { class: "info-light-title" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)
const _hoisted_22 = { class: "info-item" }
const _hoisted_23 = { class: "info-label-title" }
const _hoisted_24 = { class: "info-label-content" }
const _hoisted_25 = { class: "info-item" }
const _hoisted_26 = { class: "info-label-title" }
const _hoisted_27 = { class: "info-label-content" }
const _hoisted_28 = { class: "info-item" }
const _hoisted_29 = { class: "info-label-title" }
const _hoisted_30 = { class: "info-label-content" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)
const _hoisted_32 = { class: "info-light-title" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)
const _hoisted_34 = { class: "info-item display-flex align-items-center" }
const _hoisted_35 = { class: "info-label-title" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)
const _hoisted_37 = { class: "info-light-title" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)
const _hoisted_39 = { class: "info-item" }
const _hoisted_40 = { class: "info-label-title" }
const _hoisted_41 = { class: "info-item" }
const _hoisted_42 = { class: "info-label-title" }
const _hoisted_43 = { class: "info-item" }
const _hoisted_44 = { class: "info-label-title" }
const _hoisted_45 = { class: "popover-text" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)
const _hoisted_48 = { class: "display-flex padding-top6px box-size-border-box" }
const _hoisted_49 = { class: "info-light-title" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)
const _hoisted_51 = { class: "info-light-title" }
const _hoisted_52 = { class: "popover-text" }
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "height15px" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_steps = _resolveComponent("el-steps")
  const _component_user_form = _resolveComponent("user-form")
  const _component_office_form = _resolveComponent("office-form")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_button_tip = _resolveComponent("button-tip")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_pin_encrypt_input = _resolveComponent("pin-encrypt-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_question_tip = _resolveComponent("question-tip")
  const _component_choose_img = _resolveComponent("choose-img")
  const _component_access_group_model = _resolveComponent("access-group-model")
  const _component_set_access = _resolveComponent("set-access")
  const _component_payment_tips_dialog = _resolveComponent("payment-tips-dialog")
  const _component_pay_app = _resolveComponent("pay-app")
  const _component_face_recognition_enrollment_dialog = _resolveComponent("face-recognition-enrollment-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadHeaders }, null, 8, ["headers"]),
    _createVNode(_component_el_steps, {
      active: _ctx.step,
      "finish-status": "success",
      class: "width1000px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_step, {
          title: _ctx.$wordList.ProperAllTextInformation
        }, null, 8, ["title"]),
        _createVNode(_component_el_step, {
          title: _ctx.$wordList.ProperAllTextAccessAuthorization
        }, null, 8, ["title"])
      ]),
      _: 1
    }, 8, ["active"]),
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      (_ctx.step == 0)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (_ctx.projectType==='community')
              ? (_openBlock(), _createBlock(_component_user_form, {
                  key: 0,
                  onRoomChange: _ctx.roomChange,
                  onSubmit: _ctx.formSubmit,
                  commit: _ctx.formCommit
                }, null, 8, ["onRoomChange", "onSubmit", "commit"]))
              : _createCommentVNode("", true),
            (_ctx.projectType==='office')
              ? (_openBlock(), _createBlock(_component_office_form, {
                  key: 1,
                  onSubmit: _ctx.officeFormSubmit,
                  commit: _ctx.formCommit
                }, null, 8, ["onSubmit", "commit"]))
              : _createCommentVNode("", true),
            _createVNode(_component_cus_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkForm('next'))),
              type: "blue",
              class: "margin-right20px"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootNext), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_cus_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkForm('save')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextSaveOnly), 1)
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createBlock("div", _hoisted_3, [
            (_ctx.projectType==='community')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode("b", _hoisted_4, _toDisplayString(_ctx.$wordList.ProperAllTextResident), 1),
                  _hoisted_5,
                  _createVNode("div", _hoisted_6, [
                    _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$wordList.TabelPersonUserInHtmlName) + ": ", 1),
                    _createVNode("label", _hoisted_8, [
                      _createTextVNode(_toDisplayString(_ctx.basicData.FirstName + ' ' + _ctx.basicData.LastName) + " ", 1),
                      (_ctx.accountType == 'main')
                        ? (_openBlock(), _createBlock(_component_button_tip, { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextMasterAccount), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_button_tip, {
                            key: 1,
                            color: "#676767"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextMemberAccount), 1)
                            ]),
                            _: 1
                          }))
                    ])
                  ]),
                  _createVNode("div", _hoisted_9, [
                    _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$wordList.DeviceDetailDetailUnitName) + ": ", 1),
                    _createVNode("label", _hoisted_11, _toDisplayString(_ctx.buildName), 1)
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$wordList.RDeviceSearchLabelRoomName) + ": ", 1),
                    _createVNode("label", _hoisted_14, _toDisplayString(_ctx.aptName), 1)
                  ]),
                  (_ctx.community.isNew.value)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _hoisted_15,
                        _createVNode("b", _hoisted_16, _toDisplayString(_ctx.$wordList.AccessFloor), 1),
                        _hoisted_17,
                        _createVNode("div", _hoisted_18, [
                          _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$wordList.AccessFloor), 1),
                          _createVNode(_component_cus_select, {
                            multiple: "",
                            isShowFilterInputProp: true,
                            placeholder: _ctx.curFloor,
                            modelValue: _ctx.accessForm.AccessFloor,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.accessForm.AccessFloor = $event)),
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeFloor('community'))),
                            style: {"width":"300px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.floorOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_cus_option, {
                                  key: item.key,
                                  label: item.value,
                                  value: item.key
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["placeholder", "modelValue"])
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.projectType==='office')
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createVNode("b", _hoisted_20, _toDisplayString(_ctx.officeRole[Number(_ctx.basicData.Role)]), 1),
                  _hoisted_21,
                  _createVNode("div", _hoisted_22, [
                    _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$wordList.TabelPersonUserInHtmlName) + ": ", 1),
                    _createVNode("label", _hoisted_24, _toDisplayString(_ctx.basicData.FirstName + ' ' + _ctx.basicData.LastName), 1)
                  ]),
                  _createVNode("div", _hoisted_25, [
                    _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$wordList.ProperAllTextID) + ": ", 1),
                    _createVNode("label", _hoisted_27, _toDisplayString(_ctx.employeeID), 1)
                  ]),
                  _createVNode("div", _hoisted_28, [
                    _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$wordList.ProperAllTextDepartment) + ": ", 1),
                    _createVNode("label", _hoisted_30, _toDisplayString(_ctx.buildName), 1)
                  ]),
                  _hoisted_31,
                  _createVNode("b", _hoisted_32, _toDisplayString(_ctx.$wordList.AccessFloor), 1),
                  _hoisted_33,
                  _createVNode("div", _hoisted_34, [
                    _createVNode("label", _hoisted_35, _toDisplayString(_ctx.$wordList.AccessFloor), 1),
                    _createVNode(_component_cus_select, {
                      multiple: "",
                      modelValue: _ctx.accessForm.Floor,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.accessForm.Floor = $event)),
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeFloor('office'))),
                      style: {"width":"300px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.floorOptions, (item) => {
                          return (_openBlock(), _createBlock(_component_cus_option, {
                            key: item.key,
                            label: item.value,
                            value: item.key
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _hoisted_36,
            _createVNode("b", _hoisted_37, _toDisplayString(_ctx.$wordList.ProperAllTextAccessType), 1),
            _hoisted_38,
            _createVNode(_component_el_form, {
              model: _ctx.accessForm,
              rules: _ctx.ruleAccess,
              ref: "accessFormRef"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_39, [
                  _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$wordList.ProperAllTextPIN), 1),
                  _createVNode(_component_el_form_item, {
                    class: "display-inline-block",
                    prop: "PIN"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_pin_encrypt_input, {
                        modelValue: _ctx.accessForm.PIN,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.accessForm.PIN = $event)),
                        class: "width300px"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", _hoisted_41, [
                  _createVNode("label", _hoisted_42, _toDisplayString(_ctx.$wordList.DeliveryRfCard), 1),
                  _createVNode(_component_el_form_item, {
                    class: "display-inline-block",
                    prop: "Card"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.accessForm.Card,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.accessForm.Card = $event)),
                        class: "width300px"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            _createVNode("div", _hoisted_43, [
              _createVNode("label", _hoisted_44, [
                _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextFaceID) + " ", 1),
                _createVNode(_component_question_tip, { placement: "top-start" }, {
                  default: _withCtx(() => [
                    _createVNode("p", _hoisted_45, _toDisplayString(_ctx.$wordList.ProperAllTextFaceTip), 1)
                  ]),
                  _: 1
                })
              ]),
              _hoisted_46,
              _createVNode(_component_choose_img, {
                beforeChoose: _ctx.beforeChooseFace,
                onChange: _ctx.chooseFile,
                onRemove: _ctx.removeFile
              }, null, 8, ["beforeChoose", "onChange", "onRemove"])
            ]),
            _hoisted_47,
            _createVNode(_component_access_group_model, {
              roomId: _ctx.basicData.RoomID,
              departmentId: _ctx.basicData.DepartmentID,
              role: _ctx.basicData.Role,
              selectItem: _ctx.sysAccess,
              onWatchSelectValue: _ctx.multipleSelectValue,
              onGetSysAccess: _ctx.getSysAccess
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_48, [
                  _createVNode("b", _hoisted_49, _toDisplayString(_ctx.$wordList.ProperAllTextAccessGroup), 1)
                ])
              ]),
              _: 1
            }, 8, ["roomId", "departmentId", "role", "selectItem", "onWatchSelectValue", "onGetSysAccess"]),
            (_ctx.haveSelfDevices && _ctx.community.hasHaveAccessArea.value && _ctx.projectType==='community')
              ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                  _hoisted_50,
                  _createVNode("b", _hoisted_51, [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextSelfDevicesAuthorization) + " ", 1),
                    _createVNode(_component_question_tip, { placement: "top-start" }, {
                      default: _withCtx(() => [
                        _createVNode("p", _hoisted_52, _toDisplayString(_ctx.$wordList.ProperAllTextSelfDeviceTip), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode("span", {
                      class: [_ctx.isShowSelfAccess ? 'el-icon-arrow-down' :'el-icon-arrow-up', "cursor-pointer"],
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowSelfAccess = !_ctx.isShowSelfAccess))
                    }, null, 2)
                  ]),
                  _hoisted_53,
                  _withDirectives(_createVNode("div", null, [
                    _createVNode(_component_set_access, {
                      onGetForm: _ctx.getSelfAccess,
                      initForm: _ctx.selfAccessForm,
                      commit: _ctx.selfAccessCommit,
                      type: "self",
                      id: _ctx.basicData.RoomID
                    }, null, 8, ["onGetForm", "initForm", "commit", "id"])
                  ], 512), [
                    [_vShow, _ctx.isShowSelfAccess]
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _hoisted_54,
            _createVNode(_component_cus_button, {
              type: "blue",
              onClick: _ctx.submitAccess
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
    ]),
    (_ctx.isShowTips)
      ? (_openBlock(), _createBlock(_component_payment_tips_dialog, {
          key: 0,
          onIsShowPayNow: _ctx.isShowPayNow,
          onClose: _ctx.closePayTips,
          mainId: _ctx.mainID,
          "notice-type": _ctx.noticeType,
          "notice-main-code": _ctx.noticeMainCode,
          projectType: _ctx.projectType
        }, null, 8, ["onIsShowPayNow", "onClose", "mainId", "notice-type", "notice-main-code", "projectType"]))
      : _createCommentVNode("", true),
    (_ctx.isShowPay)
      ? (_openBlock(), _createBlock(_component_pay_app, {
          key: 1,
          mainId: _ctx.mainID,
          id: _ctx.payUserID,
          payUser: "community",
          onSuccess: _ctx.routeGoToResident,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isShowPay=false))
        }, null, 8, ["mainId", "id", "onSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.isShowFaceRecognitionEnrollmentDialog)
      ? (_openBlock(), _createBlock(_component_face_recognition_enrollment_dialog, {
          key: 2,
          onClose: _ctx.cancelFaceRecognitionEnrollment,
          onAllow: _ctx.allowFaceRecognitionEnrollment
        }, null, 8, ["onClose", "onAllow"]))
      : _createCommentVNode("", true)
  ]))
}